export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";